module.exports = __webpack_public_path__ + "img/main_icon_badge_1k.c8dc095.png";